import BaseApi from "../baseApi";
import {ATTRIBUTE_TEMPLATE} from "../apiConstant";

const apiWorkManage = new BaseApi(process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL);

class AttributeTemplateApi {
  getList(request) {
    return apiWorkManage.post(`${ATTRIBUTE_TEMPLATE}/list`, request);
  }

}

export default AttributeTemplateApi;